// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ac","heading":"Bc"};